<template>
    <div
        v-on:click="plusCommodityNumber"
        :data-id="item.id"
        class="commodity-box">
        <div
            class="commodity-image-box">
            <img
                :src="imageUrl"
                :style="imageStyle"
                class="commodity-image"/>
            <div
                class="commodity-image-number"
                :style="item.number > 0 ? 'display: block' : 'display: none'">
                {{ item.number }}
            </div>
            <div
                class="commodity-image-hover-box">
                <div class="commodity-adjust-number-box">
                    <a-icon
                        v-on:click.stop="minusCommodiyNumber"
                        :data-id="item.id"
                        class="commodity-minus-button"
                        theme="filled"
                        type="minus-circle" />
                    <div
                        :class="{'commodity-input-number-animation': animated}"
                        @animationend="animated = false"
                        class="commodity-input-number">
                        {{ item.number }}
                    </div>
                    <a-icon
                        v-on:click.stop="toggleThumbnail"
                        class="commodity-images-button"
                        theme="filled"
                        type="picture" />
                </div>
            </div>
        </div>
        <div class="commodity-name">
            {{ item.name }}
            <div v-if="item.amount">
                下单 {{ item.amount }} 件
            </div>
        </div>
    </div>
</template>

<script>
 import Vue from 'vue';
 import Icon from "ant-design-vue/lib/icon";
 import EventBus from '../event/event-bus.js';

 Vue.component(Icon.name, Icon);

 export default {
     name: 'ConsumerCommodity',
     data() {
         return {
             clickThumbnailOffset: 0,
             size: 90,
             thumbnailSize: 300,
             animated: false
         }
     },
     props: {
         item: {}
     },
     components: {
     },
     computed: {
         imageUrl: function() {
             return this.item.images[0].replace(/%/g, "%25") + "?x-oss-process=image/resize,w_" + this.size
         },
         thumbnailImages: function() {
             var images = []
             for (var i = 0; i < this.item.images.length; i++) {
                 images.push(
                     this.item.images[i].replace(/%/g, "%25") + "?x-oss-process=image/resize,w_" + this.thumbnailSize
                 )
             }

             return images
         },
         imageStyle: function() {
             var borderColor = ""
             var borderSize = ""

             if (this.item.number > 0) {
                 borderSize = "2px"
                 borderColor = "#5DC55C"
             } else {
                 borderSize = "1px"
                 borderColor = "#EEE"
             }

             return "border: " + borderSize + " solid " + borderColor + "; width: " + this.size + "px; height: " + this.size + "px;"
         }
     },
     methods: {
         plusCommodityNumber(e) {
             this.$store.commit("addCommodityInShoppingList", parseInt(e.currentTarget.dataset.id))

             this.animated = true
         },
         minusCommodiyNumber(e) {
             this.$store.commit("removeCommodityFromShoppingList", parseInt(e.currentTarget.dataset.id))

             this.animated = true
         },
         toggleThumbnail(e) {
             EventBus.$emit("showCommmodityThumbnail", this.thumbnailImages)
         }
     }
 }
</script>

<style scoped>
 .commodity-box {
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     user-select: none;
 }

 .commodity-image-box {
     position: relative;
 }

 .commodity-image-hover-box {
     position: absolute;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;

     display: none;
 }

 .commodity-box:hover .commodity-image-hover-box {
     display: block;
 }

 .commodity-adjust-number-box {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
     background-color: rgba(255, 255, 255, 0.95);

     position: absolute;
     left: 0;
     right: 0;
     bottom: 0;

     height: 28px;

     margin-left: 2px;
     margin-right: 2px;
     margin-bottom: 2px;

     border-radius: 0 0 3px 3px;
     border-top: 1px solid #EEE;
 }

 .commodity-images-button {
     color: #AAA;
     font-size: 16px;
     margin-right: 5px;
 }

 .commodity-images-button:hover {
     color: #5DC55C;
 }

 .commodity-minus-button {
     color: #AAA;
     font-size: 16px;
     margin-left: 5px;
 }

 .commodity-minus-button:hover {
     color: #D80E3B;
 }

 .commodity-input-number {
     font-size: 26px;
     color: #444;
     margin-left: 10px;
     margin-right: 10px;
     text-align: center;
     flex: 1;
 }

 .commodity-input-number-animation {
     -moz-animation: enlarge 0.2s forwards;
     -ms-animation: enlarge 0.2s forwards;
     -o-animation: enlarge 0.2s forwards;
     animation: enlarge 0.2s forwards;
 }

 @-webkit-keyframes enlarge{
     50% {-webkit-transform: scale(1.5,1.5)}
     100% {-webkit-transform: scale(1,1)}
 }
 @-ms-keyframes enlarge{
     50% {-ms-transform: scale(1.5,1.5)}
     100% {-ms-transform: scale(1,1)}
 }
 @-o-keyframes enlarge{
     50% {-o-transform: scale(1.5,1.5)}
     100% {-o-transform: scale(1,1)}
 }
 @-moz-keyframes enlarge{
     50% {-moz-transform: scale(1.5,1.5)}
     100% {-moz-transform: scale(1,1)}
 }
 @keyframes enlarge{
     50% {transform: scale(1.5,1.5)}
     100% {transform: scale(1,1)}
 }

 .commodity-image {
     border-radius: 5px;
     box-sizing: border-box;
 }

 .commodity-image-number {
     color: #444;
     position: absolute;
     bottom: 0;
     right: 0;
     font-size: 26px;
     font-weight: 500;
     margin-right: 10px;
     margin-bottom: 0px;
     text-shadow: 0 0 6px #FFF, 0 0 6px #FFF, 0 0 6px #FFF;
 }

 .commodity-name {
     font-size: 12px;
     color: #666666;
     margin-top: 5px;
     margin-bottom: 5px;
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     width: 90px;
     text-align: center;
 }

</style>
